import { capitalizeEveryWords } from "../string";
import { HUMANIZED_PLAN_ALIASES, PLAN_EXTRAS } from "./constants";
import { IPlanExtra } from "./types";

export function formatPlanName(shortName: string): string {
  return capitalizeEveryWords(
    shortName
      .toLowerCase()
      .split("-")
      .join(" ")
      .replace("self hosted", "self-hosted")
      .replace("metabase", "")
      .trim(),
  );
}

export function formatPlanShortName(shortName: string): string {
  return shortName.replace("Cloud", "").replace("Self-Hosted", "").trim();
}

export function humanisePlanAlias(alias: string): string {
  return HUMANIZED_PLAN_ALIASES[alias];
}

export function isStarterPlan(alias: string): boolean {
  return alias.startsWith("starter");
}

export function isProPlan(alias: string): boolean {
  return alias.startsWith("pro-") || alias === "pro";
}

export function isEnterprisePlan(alias: string): boolean {
  return alias.startsWith("enterprise-") || alias === "business";
}

export function isEmbeddingPlan(alias: string): boolean {
  return alias.startsWith("embedding_") || alias.startsWith("embedding-");
}

export function isLegacyPlan(alias: string): boolean {
  return (
    alias === "original" ||
    alias === "growth" ||
    alias === "startup" ||
    alias === "starter-v2" ||
    alias === "growth-v2.0"
  );
}

export function isSelfHostedPlan(alias: string): boolean {
  return !(
    alias.includes("internal") ||
    alias.includes("-cloud") ||
    isStarterPlan(alias) ||
    isEmbeddingPlan(alias) ||
    // legacy hosted plans
    alias.includes("startup") ||
    alias.includes("growth") ||
    alias.includes("original") ||
    alias.includes("business")
  );
}

export function isYearlyPlan(alias: string): boolean {
  return alias.includes("-yearly");
}

export function isDevPlan(alias: string): boolean {
  return alias.includes("-dev");
}

export function getPlanExtra(alias: string): IPlanExtra | undefined {
  return PLAN_EXTRAS[alias];
}
